/*
 * @Author: 张锐
 * @Date: 2021-04-28 18:17:29
 * @LastEditTime: 2021-05-07 14:09:38
 * @Description: 云服务相关接口
 */

import request from '@comm/utils/request'
const APIPort = process.env.APIPort;
const conversionService = 'conversion'
const priInvoice = 'invoice'
/**
 * @description:  获取虚拟用户
 * @return {String} 返回token
 */
export function getVirtyalUser () {
  return request({
    url: `${conversionService}/virtual/user`,
    method: 'get'
  })
}

/**
 * @description:  记录用户点击记录
 * @return {*}
 */
export function getOpenRecord (params) {
  return request({
    url: `${conversionService}/open/record`,
    method: 'get',
    params
  })
}

/**
 * @description:  获取下载链接
 * @return {*}
 */
 export function getLink () {
  return request({
    url: `${conversionService}/lconUrl/query`,
    method: 'get'
  })
}


/**
 * @description: 转换成TXT
 */
export function transferToTxt (data) {
  return request({
    url: `${conversionService}/ofdTransfer/toTxt/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 转换成Ofd
 */
export function transferToOfd (data) {
  return request({
    url:`${conversionService}/convert/toOfd`,
    method: 'post',
    data
  })
}

/**
 * @description: 转换成PDF
 */
export function transferToPdf (data) {
  return request({
    url: `${conversionService}/convert/toPdf`,
    method: 'post',
    data
  })
}

/**
 * @description: OFD转换成PDF
 */
export function transferOfdToPdf (data) {
  return request({
    url: `${conversionService}/convert/ofdToPdf`,
    method: 'post',
    data
  })
}

/**
 * @description: 转换成txt轮询
 */
export function getConversionFileData (data) {
  return request({
    url: `${conversionService}/ofdTransfer/getConversionFileData/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 轮询转换
 */
export function transferPoll (data) {
  return request({
    url: `${conversionService}/transfer/poll?ticket=${data}`,
    method: 'post'
  })
}


/**
 * @description: 获取文件信息
 */
export function getFileInfo (data) {
  return request({
    url: `${conversionService}/file/upload/getFileInfo/v1`,
    method: 'post',
    data
  })
}


/**
 * @description: 获取图片
 */
export function getImg (data) {
  return request({
    url: `${conversionService}/fileTransfer/getImg`,
    method: 'post',
    data
  })
}

/**
 * @description: OFD转换成图片
 */
// export function ofdToImage (data) {
//   return request({
//     url: publicApi?`${conversionService}/fileTransfer/convertToImg`:`/${conversionService}/convert/ofdToImage`,
//     method: 'post',
//     data
//   })
// }

/**
 * @description: 图片转换成OFD
 */
export function imageToOfd (toimg,data) {
  return request({
    url: toimg?`${conversionService}/fileTransfer/convertToImg`:`${conversionService}/imageToOFD/convert`,
    method: 'post',
    data
  })
}

/**
 * @description: 发票上传
 */
export function invoiceUpload (data) {
  return request({
    url: `${priInvoice}/invoice-info/upload`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取发票信息
 */
export function invoiceInfo (params) {
  return request({
    url: `${priInvoice}/invoice-info/info`,
    method: 'get',
    params
  })
}

/**
 * @description: 下载PDF
 */
export function downloadPdf (params) {
  return request({
    url: `${priInvoice}/invoice-info/downloadPdf`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * @description: 下载TPG图片
 */
export function downloadJpg (params) {
  return request({
    url: `${priInvoice}/invoice-info/downloadJpg`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 公有云服务
/**
 * @description: 通用文件上传
 */
export function uploadBurstFile (data) {
  return request({
    url: `${conversionService}/upload/uploadBurstFile/common/v1`,
    method: 'post',
    data,
    contentType: false,
    processData: false,
  })
}

/**
 * @description: 查询文件上传信息
 */
export function queryFileUploadInfo (data) {
  return request({
    url: `${conversionService}/upload/queryFileUploadInfo/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取WPS用户信息
 */
export function getWpsUserInfoByCode (data) {
  return request({
    url: '/pubwpslogin/wps/getWpsUserInfoByCode/v1',
    method: 'post',
    data
  })
}

/**
 * @description: 文件打包下载
 */
export function packZipDownload (data) {
  return request({
    url: `${conversionService}/upload/downloadZipFile/v1`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * @description: 单个下载
 */
export function downloadUploadFile (params) {
  return request({
    url: `${conversionService}/upload/downUploadFile/v1`,
    method:'get',
    params,
    responseType: 'blob'
  })
}

/**
 * @description: 合并转换
 */
export function fileTransfer (isMerge,data) {
  return request({
    url: isMerge?`${conversionService}/fileTransfer/convert`:`${conversionService}/fileTransfer/oneFileConvert`,
    method: 'post',
    data
  })
}


/**
 * @description: 单文件转换
 */
export function oneFileConvert (data) {
  return request({
    url: `${conversionService}/fileTransfer/oneFileConvert`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取长图
 */
 export function getTransferLongImg (data) {
  return request({
    url: `${conversionService}/fileTransfer/getLongImg`,
    method: 'post',
    data
  })
}

/**
 * @description: 下载埋点
 */
 export function downPcReader (data) {
  return request({
    url: `${conversionService}/buried/downPcReader`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取预览链接
 */
 export function pubserviceUpload (data) {
  return request({
    url: `pubservice/file/upload`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取文件夹信息
 */
 export function queryByDirId (data) {
  return request({
    url: `pubservice/directory/queryByDirId`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取文件信息
 */
 export function getShortUrl (params) {
  return request({
    url: `pubservice/file/${params}`,
    method: 'get',
  })
}

/**
 * @description: 获取文件信息轮询
 */
 export function getShortUrlPoll (params) {
  return request({
    url: `pubservice/file/poll/${params}`,
    method: 'get',
  })
}

/**
 * @description: 轻阅读下载
 */
 export function downloadqyd (params) {
  return request({
    url: `pubservice/file/download?fileId=${params}`,
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * @description: 获取预览链接
 */
 export function shareCreate (data) {
  return request({
    url: `pubservice/share/create`,
    method: 'post',
    data
  })
}

/**
 * @description: 获取分享信息
 */
 export function shareInfo (params) {
  return request({
    url: `pubservice/share/info/${params}`,
    method: 'get',
  })
}

/**
 * @description: 获取转换后文档信息
 */
 export function transferFileInfo (params) {
  return request({
    url: `${conversionService}/transfer/fileInfo/${params}`,
    method: 'get',
  })
}

/**
 * @description: 获取发票文档信息
 */
 export function invoiceInfoFileInfo (params) {
  return request({
    url: `${priInvoice}/invoice-info/fileInfo/${params}`,
    method: 'get',
  })
}

/**
 * @description: 在线预览主页面停留时长
 */
 export function eventStay (data) {
  return request({
    url: `pubevent/api/v1/event/stay/save`,
    method: 'post',
    data
  })
}

/**
 * @description: 在线预览上传文件埋点
 */
 export function eventUpload (data) {
  return request({
    url: `pubevent/api/v1/event/upload/save`,
    method: 'post',
    data
  })
}

/**
 * @description: 在线预览上传文件埋点
 */
 export function eventCount (data) {
  return request({
    url: `pubevent/api/v1/event/count/save`,
    method: 'post',
    data
  })
}

/**
 * @description: 在线预览打开轻阅读耗时埋点
 */
 export function eventLoading (data) {
  return request({
    url: `pubevent/api/v1/event/loading/save`,
    method: 'post',
    data
  })
}


/**
 * @description: 获取二级菜单
 */
 export function getChliden (data) {
  return request({
    url: `api/initialize/conversion/function/get`,
    method: 'post',
    data
  })
}

/**
 * @description: 电子凭证示例文档下载
 */
 export function downElectronicVoucher (params) {
  return request({
    url: `conversion/lconUrl/downElectronicVoucher/v1`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * @description: 电子凭证上传文档xbrl附件打包下载
 */
 export function downVoucher (data) {
  return request({
    url: `pubelec/api/voucher_info/downVoucher/v1`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * @description: 电子凭证上传文档提取元数据下载
 */
 export function downMetadata (data) {
  return request({
    url: `pubelec/api/voucher_info/downMetadata/v1`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * @description: 电子凭证上传文档图片下载
 */
 export function downloadElecJpg (data) {
  return request({
    url: `${priInvoice}/invoice-info/elec/download_jpg/v1`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

/**
 * @description: 电子凭证签章验证
 */
 export function verifyApi (data) {
  return request({
    url: `pubelec/api/voucher_info/verify/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 查询文件的是否包含元数据
 */
 export function queryMetadata (data) {
  return request({
    url: `pubelec/api/voucher_info/query_metadata/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 查询文件是否包含XBRL附件
 */
 export function queryXBRL (data) {
  return request({
    url: `pubelec/api/voucher_info/query_XBRL/v1`,
    method: 'post',
    data
  })
}


/**
 * @description: 问题反馈文件上传
 */
 export function uploadfiles (data) {
  return request({
    url: `pubservice/api/enclosure_info/uploadfiles/v1`,
    method: 'post',
    data,
    contentType: false,
    processData: false,
  })
}

/**
 * @description: 新增问题反馈信息及文件上传信息
 */
 export function saveEnclosureInfo (data) {
  return request({
    url: `pubservice/api/enclosure_info/save/v1`,
    method: 'post',
    data,
  })
}

/**
 * @description: 用户反馈列表
 */
 export function enclosureList (data) {
  return request({
    url: `pubservice/api/enclosure_info/get/v1`,
    method: 'post',
    data,
  })
}

/**
 * @description: 用户反馈查询是否可以下载文件
 */
 export function queryDownload (data) {
  return request({
    url: `pubservice/api/problem_record/query_download/v1`,
    method: 'post',
    data
  })
}

/**
 * @description: 用户反馈下载
 */
 export function downloadProblemRecord (data) {
  return request({
    url: `pubservice/api/problem_record/download/v1`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}








// WEBPACK FOOTER //
// ./src/comm/api/document-conversion/index.js